export default __webpack_public_path__ + "static/media/logo.946f7242.png";